"use client";

import { useState, useMemo, useRef, useEffect } from "react";

export default function LeagueSearchDropdown({
  leagues = [],
  onSelect,
  placeholder = "Tìm giải đấu khác...",
  showAllLeaguesOption = false,
  selectedLeague: selectedLeagueFromParent,
}) {
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [selectedLeague, setSelectedLeague] = useState(selectedLeagueFromParent ?? null);
  const [isTyping, setIsTyping] = useState(false);

  const wrapperRef = useRef(null);

  useEffect(() => {
    const name = selectedLeagueFromParent?.nameVN ?? "";
    setKeyword(name);
    setSelectedLeague(selectedLeagueFromParent ?? null);
    if (selectedLeagueFromParent != null) setIsTyping(false);
  }, [selectedLeagueFromParent]);

  const filteredLeagues = useMemo(() => {
    if (!isTyping) return leagues;

    if (!keyword) return leagues;

    return leagues.filter((l) =>
      l.name.toLowerCase().includes(keyword.toLowerCase())
    );
  }, [keyword, leagues, isTyping]);

  return (
    <div ref={wrapperRef} className="relative md:px-2">
      <div className="relative">
        {/* {selectedLeague?.logo && (
          <img
            src={selectedLeague.logo}
            alt={selectedLeague.nameVN}
            className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2"
          />
        )} */}

        <input
          value={keyword}
          onFocus={() => {
            setIsTyping(false);
            setOpen(true);
          }}
          onChange={(e) => {
            setKeyword(e.target.value);
            setSelectedLeague(null);
            setIsTyping(true);
            setOpen(true);
          }}
          placeholder={placeholder}
          name="league-search"
          className={`w-full md:w-[300px] rounded-lg border border-gray-300 py-2 px-3 text-sm outline-none focus:border-[var(--theme-primary)] bg-[var(--theme-foreground)]${
            selectedLeague ? "pl-10" : "pl-3"
          }`}
        />
      </div>

      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />

          <div className="absolute z-20 mt-1 max-h-72 w-full md:w-[300px] overflow-auto rounded-lg shadow-lg bg-[var(--theme-foreground)]">
            {showAllLeaguesOption && (
              <div
                onClick={() => {
                  setSelectedLeague(null);
                  setKeyword("");
                  setIsTyping(false);
                  setOpen(false);
                  onSelect?.(null);
                }}
                className={`flex cursor-pointer items-center gap-2 px-3 py-2 text-sm border-b border-[var(--theme-border)] hover:bg-[var(--theme-accent)]/10 ${
                  !selectedLeague ? "font-medium bg-[var(--theme-primary)]/10" : ""
                }`}
              >
                <span>Tất cả giải đấu</span>
              </div>
            )}
            {filteredLeagues.length === 0 ? (
              <div className="px-3 py-2 text-sm">Không tìm thấy giải đấu</div>
            ) : (
              filteredLeagues.map((league) => {
                const isActive = selectedLeague?.id === league.id;

                return (
                  <div
                    key={league.id}
                    onClick={() => {
                      setSelectedLeague(league);
                      setKeyword(league.nameVN);
                      setIsTyping(false);
                      setOpen(false);
                      onSelect?.(league);
                    }}
                    className={`flex cursor-pointer items-center gap-2 px-3 py-2 text-sm border-b border-[var(--theme-border)] py-4
                      ${
                        isActive
                          ? "hover:bg-[var(--theme-primary)]/10 font-medium"
                          : "hover:bg-[var(--theme-accent)]/10"
                      }`}
                  >
                    {league.logo && (
                      <img
                        src={league.logo}
                        alt={league.nameVN}
                        className="h-5 w-5"
                      />
                    )}
                    <span>{league.nameVN}</span>
                  </div>
                );
              })
            )}
          </div>
        </>
      )}
    </div>
  );
}
